<template>
  <button class="mdc-button mdc-button--unelevated"
    ref="button"
    :style="customStyle"
    v-on:click="clicked"
    :class="{ disabled: disabled, big: big, fill: fill, inverted: inverted, red:red }"
    :tabindex="tabindex">

    <div class="mdc-button__ripple"></div>

    <span class="mdc-button__label">
      <slot></slot>
    </span>
    
  </button>
</template>

<script>
/*
https://material.io/develop/web/components/buttons/
*/

import ButtonMixin from '../ButtonMixin'


export default {
  name: 'AccountsMdcButton',
  mixins: [
    ButtonMixin
  ],
  props: {
    inverted: {
      type: Boolean,
      default: false
    },
    red: {
      type: Boolean,
      default: false
    },
    fill: {
      type: Boolean,
      default: false
    },
    big: {
      type: Boolean,
      default: false
    },
    href: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: null
    },
    backgroundColor: {
      type: String,
      default: null
    },
    tabindex: {
      type: [String, Number],
      default: -1
    }
  },
  computed: {
    customStyle () {
      let obj = {}

      if (this.color) {
        obj['color'] = this.color
      }
      if (this.backgroundColor) {
        obj['background-color'] = this.backgroundColor
      }
      return obj
    }
  },
  methods: {
    clicked (ev) {
      if (this.href) {
        window.location.href = this.href
      } else {
        this.$emit('click', ev)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../scss/accounts.theme";

@import "@material/button/mdc-button";
@import "@material/ripple/mdc-ripple";

.mdc-button {
  font-weight: normal;
  /* font-size: 13px; */
}
.mdc-button.inverted {
  @include mdc-button-ink-color($primary);
  @include mdc-button-container-fill-color($secondary);

  .mdc-button__ripple {
    @include mdc-states($primary);
  }
}
.mdc-button.red {
  @include mdc-button-ink-color(#fff);
  @include mdc-button-container-fill-color($red);

  .mdc-button__ripple {
    @include mdc-states(#fff);
  }
}
</style>
